// import { useNav } from "../hooks/useNav";
import { Button, Collapse, Flex } from "antd";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { ReactNode } from "react";
import Layout from "../components/layout";
import Container from "../components/container";
import { useNav } from "../hooks/useNav";

const data = [
  {
    title: "Come funziona",
    questions: [
      {
        title: "Come funziona In Buona Salute?",
        content: "Compila il breve questionario. In base alle tue risposte, il nostro algoritmo suggerirà uno psiconcologo del nostro team. Potrai quindi fissare un appuntamento iniziale. In seguito deciderai se proseguire con il percorso proposto."
      },
      {
        title: "Perché affidarsi a In Buona Salute per il supporto durante la malattia?",
        content: "La nostra piattaforma vanta specialisti in psiconcologia, tutti con una profonda esperienza e competenza nel settore."
      },
      {
        title: "Come individuare lo psiconcologo giusto?",
        content: "Ci prendiamo cura di guidarti in questo: dopo aver completato un questionario online, ti suggeriremo lo specialista più in linea con le tue necessità."
      },
      {
        title: "Qual è la durata di un percorso di supporto su In Buona Salute?",
        content: "Ogni percorso di supporto psiconcologico è personalizzato. Tuttavia, consigliamo un ciclo di 10 sedute."
      }
    ]
  },
  {
    title: "Sedute",
    questions: [
      {
        title: "Quanto dura una sessione?",
        content: "50 minuti"
      },
      {
        title: "Come posso fissare il colloquio iniziale?",
        content: "Dopo aver completato il questionario online, il nostro algoritmo ti indicherà lo psiconcologo più adatto. Potrai quindi prenotare direttamente dal tuo profilo personale secondo le tue esigenze."
      },
      {
        title: "Posso rimandare o annullare una sessione?",
        content: "Certamente, puoi comunicare direttamente con il tuo psiconcologo tramite chat per modificare o annullare un appuntamento. Ti chiediamo solo di darci almeno 24 ore di preavviso."
      },
      {
        title: "Posso cambiare psiconcologo se non mi trovo bene?",
        content: "Sì, puoi farlo senza alcun costo aggiuntivo."
      },
      {
        title: "Come posso condividere un feedback?",
        content: "Al termine della sessione, ti verrà mostrata una finestra pop-up dove potrai lasciare una recensione sulla tua esperienza."
      },
      {
        title: "Posso prenotare sedute per mio figlio/a minorenne?",
        content: "Sì, è possibile prenotare sedute per il vostro figlio/a minorenne, ma è necessario fornire il vostro consenso come genitori o tutori legali. Per procedere, scriveteci una mail a supporto@inbuonasalute.eu: vi invieremo il materiale necessario da firmare per autorizzare le sedute."
      },
    ]
  },
  {
    title: "Aspetti tecnici",
    questions: [
      {
        title: "Come posso accedere alla sessione?",
        content: "È facile: entra nella tua area personale e clicca su \"inizia videochiamata\"."
      },
      {
        title: "È necessario un computer per accedere?",
        content: "No, puoi utilizzare anche uno smartphone. L'importante è avere una connessione stabile."
      },
      {
        title: "Come posso contattare il supporto di In Buona Salute?",
        content: <>Puoi scrivere all&apos;indirizzo email <a href="mailto:supporto@inbuonasalute.it">supporto@inbuonasalute.it</a>.</>
      },
      {
        title: "Come posso eliminare il mio account?",
        content: "Per disattivare il tuo account, scrivi al nostro servizio di supporto."
      },
    ]
  },
  {
    title: "Quanto Costa?",
    questions: [
      {
        title: "Quanto costa una sessione?",
        content: "Il primo colloquio conoscitivo di 15-20 minuti è gratuito, successivamente il costo di ogni sessione è di 59€."
      },
      {
        title: "Come posso effettuare il pagamento?",
        content: "Il pagamento avviene direttamente tramite la nostra piattaforma al momento della prenotazione. Per garantire la massima sicurezza, utilizziamo Stripe, una delle piattaforme di pagamento online più affidabili e sicure."
      },
    ]
  },
  {
    title: "Per psiconcologi",
    questions: [
      {
        title: "Ci sono costi associati per i professionisti che si uniscono a In Buona Salute?",
        content: "Non ci sono costi di iscrizione o abbonamento. Tuttavia, tratteniamo una commissione per ogni sessione condotta dallo psiconcologo."
      },
      {
        title: "Come posso gestire le sessioni con i pazienti di In Buona Salute?",
        content: "La nostra piattaforma ti fornirà tutti gli strumenti necessari per monitorare il tuo lavoro, comunicare direttamente con i pazienti e organizzare i tuoi appuntamenti in autonomia."
      },
    ]
  }
];

const collapseIcon = ({ isActive }: { isActive?: boolean }): ReactNode => {
  return (
    <div className="relative">
      <PlusCircleOutlined style={{
        transform: `rotate(${!isActive ? -180 : 0}deg)`,
        opacity: !isActive ? 1 : 0,
        fontSize: 20,
        color: "#98A2B3",
        transition: "transform .3s linear"
      }}
      />
      <MinusCircleOutlined style={{
        position: "absolute",
        left: 0,
        top: 0,
        transform: `rotate(${isActive ? 180 : 0}deg)`,
        opacity: isActive ? 1 : 0,
        fontSize: 20,
        color: "#98A2B3",
        transition: "transform .3s linear"
      }}
      />
    </div>
  );
};

const panelStyle: React.CSSProperties = {
  borderBottom: "1px solid #dee2e6",
  fontSize: 16,
  paddingBottom: 8,
};

const Faq = () => {
  const { navContacts } = useNav();

  return (
    <Layout>
      <Container className="py-[3rem]">
        <h1 className="font-bold text-[2.5rem] text-center leading-[1.1] mb-[7.5rem]">Domande Frequenti</h1>
        <div className="max-w-[768px] w-full   mx-auto">
          {data.map((item: any) => (
            <div key={item.title} className="mb-[3rem]">
              <h2 className="text-[1.75rem] font-bold mb-[1.5rem]">{item.title}</h2>
              <Collapse
                expandIcon={collapseIcon}
                expandIconPosition="end"
                ghost
                accordion
                items={item.questions.map((collapseItem: any, index: number) => {
                  return {
                    key: index,
                    label: collapseItem.title,
                    children: <p className="text-base mb-0">{collapseItem.content}</p>,
                    style: panelStyle,
                    styles: {
                      body: {
                        padding: "16px 20px",
                      }
                    }
                  };
                })}
              />
            </div>
          ))}
        </div>
        <Flex vertical className="bg-[#ECF9F8] rounded-[10px] py-[1.5rem]" align="center">
          <img src="/landing/faq-contacts.webp" alt="faq" className="max-w-[142px] mb-[1rem]"/>
          <p className="text-base mb-[2rem] font-bold">Ancora domande?</p>
          <Button size="large" style={{ color: "white" }} onClick={navContacts}>Contattaci</Button>
        </Flex>
      </Container>
    </Layout>
  );
};

export default Faq;
